import { Grid } from '@material-ui/core';
import React from 'react';
import { StudioControlStyles } from './styles';

type Props = {
  message: string;
};

const StudioNotification = ({ message }: Props) => {
  const classes = StudioControlStyles();

  return (
    <Grid container alignItems="center" spacing={1} className={classes.notify}>
      <Grid item>
        <span>{message}</span>
      </Grid>
    </Grid>
  );
};

export default StudioNotification;
